<template>
    <v-card
            :class="classeComputed"
            elevation="2"
            outlined
            height="100%"
            min-height="150px"
            @click="emitClick()"
    >
        <v-card-title class="justify-left pl-0 card-title color-primary">
            <slot></slot>
        </v-card-title>
        <div class="d-flex justify-center align-center">
            <v-icon style="font-size: 5rem;" color="primary">mdi-plus-circle</v-icon>
        </div>
    </v-card>
</template>

<script>
  export default {
    name: 'CardNovoItem',
    props: {
      selecionado: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      classeComputed () {
        const selecionado = this.selecionado ? 'selecionado' : ''
        return 'mx-auto px-3 hover-verde-pointer ' + selecionado
      }
    },
    methods: {

      emitClick () {
        if (!this.selecionado) {
          this.$emit('click')
        }
      }
    }

  }
</script>
<style scoped lang="scss">
    .selecionado{
    border: 2px solid var(--primary) !important;

  }
  .hover-verde-pointer{
    cursor:pointer;
    &:hover{
      border: 1px solid  var(--primary);
    }
  }
  .card-title{
    font-size: 1.5rem;
    font-weight: 1000;
    color: #000000;
  }
</style>
